import { useState, useEffect } from 'react'
import { supabase } from './supabaseClient'
import Auth from './pages/Auth'
import PostCraving from './pages/PostCraving'
import Home from './pages/Home'
import Swipe from './pages/Swipe'
import Profile from './pages/Profile'
import Matches from './pages/Matches'
import Discover from './pages/Discover'

function App() {
  const [session, setSession] = useState(null)
  const [currentScreen, setCurrentScreen] = useState('home')
  const [discoverFilter, setDiscoverFilter] = useState('')

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (!session) setCurrentScreen('home')
    })
  }, [])

  function handleNavigate(screen, opts) {
    if (screen === 'signout') {
      supabase.auth.signOut()
      return
    }
    if (screen === 'discover' && opts?.filter) {
      setDiscoverFilter(opts.filter)
    } else if (screen !== 'discover') {
      setDiscoverFilter('')
    }
    setCurrentScreen(screen)
  }

  if (!session) return <Auth />

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: '#0D0D0D',
    }}>
      {currentScreen === 'home' && (
        <Home
          session={session}
          onNavigate={handleNavigate}
          currentScreen={currentScreen}
        />
      )}
      {currentScreen === 'post' && (
  <PostCraving
    session={session}
    onNavigate={handleNavigate}
  />
)}
      {currentScreen === 'swipe' && (
        <Swipe
          session={session}
          onNavigate={handleNavigate}
        />
      )}
      {currentScreen === 'matches' && (
        <Matches
          session={session}
          onNavigate={handleNavigate}
        />
      )}
      {currentScreen === 'discover' && (
        <Discover
          session={session}
          onNavigate={handleNavigate}
          defaultFilter={discoverFilter}
        />
      )}
      {currentScreen === 'profile' && (
        <Profile
          session={session}
          onNavigate={handleNavigate}
        />
      )}
    </div>
  )
}

export default App